import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  tableWrapper: {
    width: '100%',
    padding: '14px 16px 6px',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    paddingBottom: '8px',
    borderBottom: '1px solid #ffffff1a',
  },
  headerLabel: {
    flex: 1,
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 600,
    textTransform: 'capitalize' as any,
    letterSpacing: '0.5px',
  },
  headerLabelFirst: {
    width: '60px',
    minWidth: '60px',
  },
  dataRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '7px 4px',
    borderRadius: '6px',
    transition: 'background 0.15s',
    '&:hover': {
      background: '#ffffff12',
    },
  },
  dataRowHighlight: {
    background: '#ffffff0a',
  },
  periodLabel: {
    width: '60px',
    minWidth: '60px',
    fontSize: '14px',
    color: '#ffffffdd',
    fontWeight: 600,
  },
  valueCell: {
    flex: 1,
    textAlign: 'center',
    fontSize: '14px',
    color: '#ffffffee',
  },
  profitValue: {
    color: '#5BEC5B',
  },
  lossValue: {
    color: '#FF7A63',
  },
  totalDivider: {
    width: '1px',
    height: '22px',
    background: '#ffffff20',
    margin: '0 4px',
  },
});
